var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('backlink'),_vm._v(" "),_c('h1',[_vm._v("Suivi des locations pour compte")]),_vm._v(" "),_c('AdminTable',{attrs:{"config":_vm.config,"options":_vm.options,"items_provider":_vm.itemsProvider},scopedSlots:_vm._u([{key:"remaining_days",fn:function(ref){
var data = ref.data;
return [_c('span',{class:_vm.deadlineClass(data.item)},[_vm._v("\n        "+_vm._s(data.item.remaining_days == null ? '' : data.item.remaining_days + ' j')+"\n      ")])]}},{key:"status_slug",fn:function(ref){
var data = ref.data;
return [_c('b-badge',{attrs:{"variant":data.item.status_variant}},[_vm._v("\n        "+_vm._s(data.value)+"\n      ")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e571f79","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationForAccount/LocationForAccountList.vue
// module id = 1039
// module chunks = 0